// main.js
import Vue from 'vue';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead'

Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);